<div class="user-queue-location-entry">{{formatLocation(location)}}</div>
<ul>
    @for (user of location?.userList; track user) {
<li >
        <queue-user [user]="user" [deleteUser]="deleteUser" [syncUsers]="syncUsers" [locationUserListChange]="locationUserListChange" (onError)="setError($event)"></queue-user>
    </li>
}
</ul>
